// @mui
import { useTheme } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";

// ----------------------------------------------------------------------

export default function StyledNotistack() {
  const theme = useTheme();

  const isLight = theme.palette.mode === "light";

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        "#root": {
          ".notistack-SnackbarContainer": {
            //marginTop: theme.spacing(6),
          },
          ".notistack-MuiContent": {
            width: "100%",
            padding: theme.spacing(1),
            margin: theme.spacing(0.25, 0),
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
            color: isLight
              ? theme.palette.common.white
              : theme.palette.grey[800],
            backgroundColor: isLight
              ? theme.palette.grey[900]
              : theme.palette.common.white,
            "&.notistack-MuiContent-success, &.notistack-MuiContent-error, &.notistack-MuiContent-warning, &.notistack-MuiContent-info":
              {
                // light
                color: theme.palette.success.contrastText,
                backgroundColor: theme.palette.background.paper,
              },
            // set bgcolor individually for each variant
            "&.notistack-MuiContent-success": {
              backgroundColor: theme.palette.success.main,
            },
            "&.notistack-MuiContent-error": {
              backgroundColor: theme.palette.error.main,
            },
            "&.notistack-MuiContent-warning": {
              backgroundColor: theme.palette.warning.main,
            },
            "&.notistack-MuiContent-info": {
              backgroundColor: theme.palette.info.main,
            },
            [theme.breakpoints.up("md")]: {
              minWidth: 240,
            },
          },
          "#notistack-snackbar": {
            padding: "0 !important",
            fontWeight: theme.typography.fontWeightMedium,
          },
          "#notistack-snackbar+div": {
            marginRight: 0,
            color: theme.palette.action.active,

            "& svg": {
              width: 20,
              height: 20,
            },
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
}
